import { Button, Loader } from '@ets-global/b2c-website-ui';
import { fromJS } from 'immutable';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import AccountBlock from '../../../components/Account/Block';
import { SessionCandidate, SessionHeading } from '../../../components/Account/Session';
import AccountLayout from '../../../components/Layout/Account/AccountLayout';
import { TestTypeProgram } from '../../../constants';
import { PAST_APPOINTMENTS_SESSIONS } from '../../../graphql/queries/Account/appointmentsSessions';
import { useQuery, useRouter } from '../../../hooks';
import { paths } from '../../../paths';

const PastAppointmentsSessions = () => {
  const { t } = useTranslation();
  const { lang, countryIso2 } = useRouter();
  const filters = [
    {
      field: 'sessionStatus',
      operator: 'in',
      value: ['status_session_administered', 'status_session_received', 'status_session_scored'],
    },
    {
      field: 'status',
      operator: 'in',
      value: ['status_appointment_accepted', 'status_appointment_no_show', 'status_appointment_refused'],
    },
  ];

  const {
    data: { appointmentsSessions: appointmentsSessionsList = [] },
    loading,
  } = useQuery(PAST_APPOINTMENTS_SESSIONS, { variables: { filters, lang, country: countryIso2 } });
  const appointmentsSessions = fromJS(appointmentsSessionsList);

  let content = <Loader />;

  if (!loading) {
    if (appointmentsSessions.size > 0) {
      content = appointmentsSessions.map((appointmentsSession, key) => {
        const openSession = appointmentsSession.get('openSession');

        return (
          <Fragment key={key}>
            <AccountBlock center={true} className={'account-block--no-space account-block--no-pad-bottom'}>
              <SessionHeading session={openSession} past={true} />
            </AccountBlock>
            <AccountBlock center={true} title={t('account.passed-open-sessions.registered-candidates')}>
              {appointmentsSession.get('candidates').map((candidate, key) => {
                return (
                  <SessionCandidate
                    key={key}
                    candidate={candidate}
                    hasPhoto={
                      openSession.get('testType') &&
                      openSession.get('testType').get('program') === TestTypeProgram.PP &&
                      openSession.get('testType').get('isPhotoRequired')
                    }
                    past={true}
                    sessionId={openSession.get('id')}
                    sessionIsEproctored={!openSession.get('testingSite')}
                  />
                );
              })}
            </AccountBlock>
          </Fragment>
        );
      });
    } else {
      content = (
        <section className="account-block account-block--centered">
          <p className="account-block__empty-label">{t('account.passed-open-sessions.no-tests')}</p>
          <Button to={paths.SESSION_SEARCH} aria-label={t('account.passed-open-sessions.book-test')}>
            {t('account.passed-open-sessions.book-test')}
          </Button>
        </section>
      );
    }
  }

  return <AccountLayout title={t('account.passed-open-sessions.title')}>{content}</AccountLayout>;
};

export default PastAppointmentsSessions;
